import type { LstAuthModuleOptions } from '@savvaslearning/lst-auth';

import { environment } from '../../../environments/environment';

export const AUTH_CALLBACK_ROUTE = environment.authCallbackRoute;
export const AUTH_ERROR_ROUTE = environment.errorRoute;

// Settings mirror Realize Reader's so the reader MFE shares this app's RBS session.
export const LST_MODULE_OPTIONS: LstAuthModuleOptions = {
  appId: environment.authAppId,
  authGatewayBaseUrl: environment.authGatewayBaseUrl,
  authGatewayClientId: environment.authGatewayClientId,
  authContextId: environment.authContextId,
  rbsTokenScope: environment.rbsTokenScope,
  rbsTokenGrantType: environment.rbsTokenGrantType,
  ssoBaseUrl: environment.ssoBaseUrl,
  authCallbackRoute: environment.authCallbackRoute,
  errorRoute: environment.errorRoute,
  loginQueryParams: {
    profile: 'realize',
    k12int: true,
  },
  includeLicensedProducts: false,
  storageType: 'sessionStore',
  secBeforeSessionExpiry: 120,
  ...(typeof window !== 'undefined' ? { logoutServiceUrl: `${window.location.origin}/` } : {}),
};
